import { Component, Vue, Prop } from "vue-property-decorator";
import template from "./rim-repair-modal.template.vue";

@Component({
  mixins: [template]
})
export default class RimRepairModalComponent extends Vue {
  @Prop({ default: false }) dialog!: boolean;
  @Prop({ default: "60%" }) width!: string;

  close() {
    this.$emit("close");
  }
}
